/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import {createApp, defineAsyncComponent} from 'vue';
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import loadHtml from './directives/load-html'
import tableToChart from './directives/table-to-chart'
//import navCategories from './directives/nav-categories.js' // Deprecated - Replaced by swiper
import readMore from './directives/read-more.js'
import productsFilter from './directives/products-filter.js'
import showMore from './directives/show-more.js'
import dateSelector from './directives/date-selector.js'
import cgtm from './directives/cgtm.js'
//import gallery from './directives/gallery.js' // Deprecated - Gallery + Filters in Modal | vuejs

import "./bootstrap";
import "./framework-bootstrap"; // Modal, Carousel, Placeholder, Tab, Tooltip
import "./bs-modal-preload"; // Remove backdrop when preload modal is enable
import "./bs-modal-hash"; // Enable #hash navigation to Boostrap modal
import "./bs-modal-video";
import "./swiper"; // Sliders
import "./navigation";
import "./open-resume";
import "./href";
import "./preload";
import "./forms";
import "./responsive";
import "./page-product";
import "./gallery-swiper"; // Gallery + Filters + Swiper in Modal | vanillajs
import "./hotelStorage";
import "./newsletter";
import debounce from './debouncer.js';
//import { scrollDirection } from './scrollDirection';
import lazysizes from 'lazysizes';


const DevisExpress = defineAsyncComponent(() => import('./components/DevisExpress.vue'));
const DemandeDevis = defineAsyncComponent(() => import('./components/DemandeDevis.vue'));
const DevisCombine = defineAsyncComponent(() => import('./components/DevisCombine.vue'));
const DevisActivite = defineAsyncComponent(() => import('./components/DevisActivite.vue'));
const DevisContact = defineAsyncComponent(() => import('./components/DevisContact.vue'));
const RappelGratuit = defineAsyncComponent(() => import('./components/RappelGratuit.vue'));
const ProductCalendar = defineAsyncComponent(() => import('./components/ProductCalendar.vue'));
//const HotelsChains = defineAsyncComponent(() => import('./components/Hotels/HotelsChains.vue'));
const HotelDialogFourRaisons = defineAsyncComponent(() => import('./components/Hotel/HotelDialogFourRaisons.vue'));
const ProductsMap = defineAsyncComponent(() => import('./components/ProductsMap.vue'));
const ProductsMapCircuit = defineAsyncComponent(() => import('./components/ProductsMapCircuit.vue'));
const SearchAutocomplete = defineAsyncComponent(() => import('./components/SearchAutocomplete.vue'));
const Reservation = defineAsyncComponent(() => import('./components/Reservation/Reservation.vue'));


const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// directive display in modal
if(document.getElementById('forms')){
    createApp({})
        .component('devis-express', DevisExpress)
        .component('demande-devis', DemandeDevis)
        .component('devis-combine', DevisCombine)
        .component('devis-activite', DevisActivite)
        .component('devis-contact', DevisContact)
        .component('rappel-gratuit', RappelGratuit)
        .component('reservation', Reservation)
        .component('product-calendar', ProductCalendar)
        .directive('cgtm', cgtm)
        .use(pinia)
        .mount('#forms')
}

// directive display in navigation
if(document.getElementById('search-autocomplete')){
    createApp({})
        .directive('debounce', (el,binding) => debounce(el,binding))
        .component('search-autocomplete', SearchAutocomplete)
        .mount('#search-autocomplete')
}

// directive display in page
if(document.getElementById('app')) {
    createApp({})
		.component('hotel-dialog-four-raisons', HotelDialogFourRaisons)
		//.component('hotels-chains', HotelsChains)
        .component('product-calendar', ProductCalendar)
        .component('products-map', ProductsMap)
        .component('products-map-circuit', ProductsMapCircuit)
        .component('demande-devis', DemandeDevis)
        .component('reservation', Reservation)
        .component('devis-combine', DevisCombine)
        .component('devis-activite', DevisActivite)
        .component('devis-contact', DevisContact)
        .component('rappel-gratuit', RappelGratuit)
        .component('search-autocomplete', SearchAutocomplete)
        .directive('load-html', loadHtml)
        .directive('table-to-chart', tableToChart)
        //.directive('nav-categories', navCategories)
        .directive('read-more', readMore)
        .directive('products-filter', productsFilter)
        .directive('show-more', showMore)
        .directive('date-selector', dateSelector)
        .directive('cgtm', cgtm)
        //.directive('gallery', gallery)
        .directive('debounce', (el,binding) => debounce(el,binding))
        .use(pinia)
        .mount('#app')
}

document.addEventListener('DOMContentLoaded', function() {
    let cgtms = document.querySelectorAll('[data-cgtm]');
    cgtms.forEach(function(cgtm) {
        cgtm.addEventListener('click', function(event) {
            let nameEvent = cgtm.getAttribute('data-cgtm');
            pushToLayer(nameEvent)
        })
    })

    var formSearch = document.getElementById('formSearch');
    if(formSearch){
        formSearch.addEventListener('submit', function(event) {
            event.preventDefault();
            const formData = new FormData(event.target);
            const actionUrl = event.target.getAttribute('action');

            const regionSelect = event.target.querySelector('select[name="idRegion"]');
            const activiteSelect = event.target.querySelector('select[name="idActivite"]');
            const standingSelect = event.target.querySelector('select[name="idStanding"]');
            const standingText = standingSelect.options[standingSelect.selectedIndex].text;
            const regionText = regionSelect.options[regionSelect.selectedIndex].text;
            const activiteText = activiteSelect.options[activiteSelect.selectedIndex].text;
            pushToLayer('recherche_produit_cta', {
                hotel_star: standingText,
                region: regionText,
                travel_type: activiteText
            })

            const params = new URLSearchParams(formData);
            window.location.href = `${actionUrl}?${params.toString()}`;
        })
    }

})

// TMP : form sample
import "./form-sample-book";
import {pushToLayer} from "./util.js";
